<template>
  <div class="layout end-call anim">
    <div class="header">
      <img src="/logo.png" :height="30" />
    </div>
    <div class="end-call-content">
      <v-sheet class="end-call-feedback">
        <end-call-feedback />
      </v-sheet>
    </div>
    <div class="footer">
      <span class="term-of-use" v-html="$t('endCall.join.agreement')"></span>
    </div>
  </div>
</template>

<script setup>
import {onMounted} from 'vue'
import {useUserStore, useSessionStore, useExitStore} from '@/stores'
import {useRepository, useGoogleService} from '@/composables'
import {locationMessages} from '@/messages'
import {useWakeLock} from '@vueuse/core'
import EndCallFeedback from './EndCallFeedback.vue'

const user = useUserStore()
const exit = useExitStore()
const {release} = useWakeLock()

const {sendWsEvent, sendStats} = useRepository()
const {getDirections, getMapImage, getLink} = useGoogleService()
const session = useSessionStore()

function createSummary() {
  const {latitude: origLat, longitude: origLng, source: origSource} = exit.location
  const {latitude: destLat, longitude: destLng, source: destSource} = user.location
  if (origLat && origLng && destLat && destLng) {
    const origin = `${origLat},${origLng}`
    const destination = `${destLat},${destLng}`
    getDirections({origin, destination}).then(result => {
      const {status} = result
      if (status === 'OK') {
        const {legs, overview_polyline: polyline} = result.routes[0]
        const distance = legs.reduce((total, leg) => total + leg.distance.value, 0) * 2
        const duration = legs.reduce((total, leg) => total + leg.duration.value, 0) * 2
        const inacurrate = [origSource, destSource].includes('ip')
        const link = getLink({origin, destination})
        exit.setData(distance, duration, inacurrate, link)
        sendWsEvent(
          locationMessages.pathDirections(
            polyline.points,
            user.location,
            session.info.account,
            session.info.team ?? '',
            session.info.license
          )
        )
        sendStats({
          assistantTripKM: distance,
          assistantTripTime: duration,
          account: session.info.account,
          team: session.info.team ?? '',
          license: session.info.license,
        })
        if (session?.info?.allowMapGeneration) {
          getMapImage(polyline.points)
            .then(image => {
              exit.setImage(image)
            })
            .catch(error => {
              console.error(`googleService.getMapImage: ${error}`)
            })
        }
      } else {
        const {error_message: errorMessage} = result
        console.error(`googleService.getDirections: [${status}]${errorMessage ? ' ' + errorMessage : ''}`)
      }
    })
  } else if (session.duration) {
    sendWsEvent(
      locationMessages.pathDirections(
        '',
        user.location,
        session.info.account,
        session.info.team ?? '',
        session.info.license
      )
    )
    sendStats({
      assistantTripKM: 0,
      assistantTripTime: 0,
      account: session.info.account,
      team: session.info.team ?? '',
      license: session.info.license,
    })
  }
}

onMounted(() => {
  if (user.isAssistant) {
    createSummary()
  }
  release()
})
</script>
<style scoped lang="scss">
@import '@/scss/layout';
</style>
<style lang="scss" scoped>
.end-call-content {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  margin-top: 64px;
  .end-call-feedback {
    @media only screen and (max-width: 768px) {
      width: 310px;
    }

    @media only screen and (min-width: 768px) {
      width: 428px;
    }
  }
}
</style>
